import { _ } from "libs";

import React, { useState, forwardRef, useImperativeHandle, useRef } from "react";
import AutocompleteInput, { OnAutocompleteInputChange, RenderFunction } from "./autocompleteInput";

type Props = {
	onChange: (values: any[]) => void;
	onInputChange: OnAutocompleteInputChange;
	renderOption: RenderFunction;
	renderValue: (value: any) => JSX.Element;
	emptyValue?: any[];
};

const MultiSelect = ({ onChange, onInputChange, renderOption, renderValue, emptyValue }: Props, ref) => {
	const [values, setValues] = useState([]);

	const input = useRef<typeof AutocompleteInput>(null as typeof AutocompleteInput);

	useImperativeHandle(ref, () => ({
		addValue: (value: any) => {
			addValue(value);
		},
		focus: () => {
			//@ts-ignore
			input.current.focus();
		},
	}));

	const addValue = (value: any) => {
		const index = values.indexOf(value);
		if (index === -1) {
			const newValues = values.concat(value);
			setValues(newValues);
			onChange(newValues);
		}
	};

	const removeValue = (key: number) => {
		const newValues = [...values];
		newValues.splice(key, 1);
		setValues(newValues);
		onChange(newValues);
	};

	const onItemSelected = (item: any) => {
		addValue(item);
	};

	const wrapOnInputChange = (input: string): any[] | Promise<any[]> => {
		return onInputChange(input);
	};

	const wrapRenderValue = (value: any, key: number): JSX.Element => {
		return (
			<div className="selectedRecipient" key={key}>
				{renderValue(value)}
				<div
					className="remove"
					onClick={e => {
						removeValue(key);
					}}
				/>
			</div>
		);
	};

	return (
		<div className="field searchField searchFieldWithIcon">
			<AutocompleteInput
				value={""}
				minLength={3}
				onChange={wrapOnInputChange}
				renderSuggestion={renderOption}
				onItemSelected={onItemSelected}
				placeholder={_("newConversation.searchRecipient.placeholder")}
				emptyValue={emptyValue}
				ref={input}
			/>
			<div className="selectedRecipients">{values.map((value, key) => wrapRenderValue(value, key))}</div>
		</div>
	);
};

export default forwardRef(MultiSelect);
